// import styled from '@emotion/styled';
// import { Box, Button, IconButton} from '@mui/material';
import { Page } from 'components/Page';
// import EmailIcon from '@mui/icons-material/Email';
// import InstagramIcon from '@mui/icons-material/Instagram';
// import FacebookIcon from '@mui/icons-material/Facebook';

// const HeaderMenu = styled(Box)`
//     text-align: center;
//     top: 101px;
//     // border: 1px #e3caaf;
//     width: 100%;
//     box-sizing: border-box;
//     z-index: 100;
//     border: 1px;
//     background-color: #282424;
//     display: flex;
// `;

// const SpotifyLink = styled.a`
// <style>
//     color: white;
//     cursor: pointer;
//     text-decoration: none;
//     background-color: transparent;
//     &:hover {
//         text-decoration: underline;
//     }
//     &:visited {
//     color: white;
//     }
// </style>
// }`;

// const Hero = styled(Box)`
//     width: 100%;
//     background-image: url(/heroimage.JPG);
//     background-repeat: no-repeat;
//     background-size: cover;
//     background-position: top;
//     box-sizing: border-box;
//     height: 880px;
//     max-height: 880px;
//     top: 0;
//     left: 0;
//     max-width: 100%;
//     z-index: 100;
// }
// `;

// // const SpotifyLinkButton = styled.a`
// //     <style>
// //       color: white;
// //       cursor: pointer;
// //       text-decoration: none;
// //       &:visited {
// //     color: white;
// //     }
// //     <style>
// // `;

// // const AppleLink = styled.a`
// //     <style>
// //       color: white;
// //       cursor: pointer;
// //       text-decoration: none;
// //       &:visited {
// //       color: white;
// //       }
// //     <style>
// //     // .button-grow {
// //     //   transition: all 0.3s;
// //     //   }
// // `;

// const Action = styled(Box)`
//     //justify-content: space-evenly;
//     // text-align: center;
//     // position: absolute;
//     border: 0px solid green;
//     width: 100vw;
//     height: 500px;
//     max-height: 500px;
//     box-sizing: border-box;
//     display: flex;
//     flex-direction: column;
//     top: 0;
//     left: 0;
//     background: url(image5.jpg);
//     background-repeat: no-repeat;
//     background-size: cover;
//     // -webkit-filter: blur(6px);
//     z-index: ;
//     border: ;
// `;

// const Shadow = styled(Box)`
//     box-sizing: border-box;
//     border: 2px solid black;
// `;

// const MediaTile = styled(Box)`
//     box-sizing: border-box;
//     width: 15.27%;
//     height: auto;
//     min-width: 274.3px;
//     min-height: 274.3px;
//     display: block;
//     border-radius: 5px;

//     @media (max-width: 480px) {
//       gap: 0;
//     }
// `;

// const AlbumRetreat = styled(MediaTile)`
//     background-image: url(smallretreat.jpeg);
// `;

// const AlbumHorse = styled(MediaTile)`
//     background-image: url(cripplehorse1.jpeg);
// `;

export const Home = () => <Page title="Home">  

  {/* <HeaderMenu>
        {" "}
    
    <SpotifyLink href="https://distrokid.com/hyperfollow/guynorth/retreat">Listen now</SpotifyLink>
    <IconButton>
      <EmailIcon/>
    </IconButton>
    <IconButton>
      <InstagramIcon/>
    </IconButton>
    <IconButton>
      <FacebookIcon href="https://www.facebook.com/guynorthmusic/"/>
    </IconButton>
  </HeaderMenu> */}

    {/* <HeaderMenu>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <SpotifyLink href="https://distrokid.com/hyperfollow/guynorth/retreat">Listen now</SpotifyLink>
        <IconButton>
          <EmailIcon/>
        </IconButton>
        <IconButton>
          <InstagramIcon/>
        </IconButton>
        <IconButton>
          <FacebookIcon href="https://www.facebook.com/guynorthmusic/"/>
        </IconButton>
      </Box>
    </HeaderMenu>

  <Hero>
  </Hero>
  <Action>
        
    <Shadow/>
    <Box sx={{display:"flex", justifyContent: "center", alignItems: "center", padding: "15px", gap: "30px"}}>
    <AlbumRetreat/>
    <AlbumHorse/>
</Box>
   
      
   
    

  </Action>
   */}

</Page>;